window.SubscriptionRequest = {
    create: function(context, plugin, relatedId, withConfirmation, successIsPopup){

        // Close already open dialog
        $('#alertWindow').dialog('close');

        if(withConfirmation == undefined){
            withConfirmation = true;
        }

        successIsPopup = successIsPopup !== undefined ? successIsPopup : false;

        var madeRequest = function(){
            SubscriptionRequest.madeRequest(context, plugin,
                successIsPopup ? { success: SubscriptionRequest.contactSales(context) } : {}, relatedId);
        };

        if(!withConfirmation){
            madeRequest();
            return;
        }

        var options = {
            type        : "confirmCustom",
            resizable   : false,
            noclose     : true,
            title       : Loc.g("Confirmation de votre demande"),
            buttons     : [
                {
                    text : Loc.g("Non"),
                    click : function(){
                        $(this).dialog("close");
                    }
                },
                {
                    text : Loc.g("Oui"),
                    click : function(){
                        madeRequest();
                        $(this).dialog("close");
                    }
                }
            ]
        };

        MyWindow.alert(Loc.g("Souhaitez-vous être recontacté par un commercial Sellsy pour obtenir plus d'informations ?"), options);

    },
    madeRequest: function(context, plugin, options, id){

        var defaultOptions = {
            success: function(){
                SubscriptionRequest.successMessage();
            }
        };

        var options = typeof options == 'object' ? options : {};

        options = Object.assign(defaultOptions, options);

        options.url = '/?_f=upsale&do=generateOpportunity';
        options.data = {
            context: context,
            plugin: plugin,
            id: id
        };

        $.ajax(options);
    },
    successMessage: function(){
        Push.success(Loc.g('Votre demande est transmise à notre équipe commerciale, vous allez être recontacté très rapidement.'));
    },
    contactSales: function(context){
        MyWindow.load('upsale', {
            action: 'contact',
            context: context
        }, {
            dialogClass: 'white no-title',
            title: '',
        });
    }
};